var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrapsiteVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 47,
    viewBox: "0 0 54 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1256_16261",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 54,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.098877,
    y: 6.66797,
    width: 53.011,
    height: 40.3333,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1256_16261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2307 41.9609L19.978 38.4318L9.70709 41.4568C8.97082 41.6808 8.28978 41.6178 7.66396 41.2677C7.03813 40.9176 6.72522 40.4484 6.72522 39.8602V16.3325C6.72522 15.9683 6.86327 15.6462 7.13937 15.3661C7.41547 15.0861 7.7928 14.876 8.27137 14.7359L19.978 11.7109L33.2307 15.2401L43.5016 12.2151C44.2379 11.991 44.9189 12.0541 45.5447 12.4042C46.1706 12.7543 46.4835 13.2234 46.4835 13.8116V37.3394C46.4835 37.7035 46.3454 38.0256 46.0693 38.3057C45.7932 38.5858 45.4159 38.7959 44.9373 38.9359L33.2307 41.9609ZM31.0219 37.8436V18.1811L22.1868 15.8283V35.4908L31.0219 37.8436ZM35.4395 37.8436L42.0659 36.163V16.2484L35.4395 18.1811V37.8436ZM11.1428 37.4234L17.7692 35.4908V15.8283L11.1428 17.5089V37.4234Z",
    fill: "#3B7EB2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_1256_16261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3407 11.7997C27.9481 11.7997 28.4682 11.5702 28.9012 11.111C29.3341 10.6518 29.5502 10.0992 29.5494 9.45307C29.5494 8.80774 29.3334 8.25549 28.9012 7.79633C28.469 7.33716 27.9488 7.10719 27.3407 7.10641C26.7332 7.10641 26.2134 7.33638 25.7813 7.79633C25.3491 8.25627 25.1326 8.80852 25.1319 9.45307C25.1319 10.0984 25.3483 10.651 25.7813 11.111C26.2142 11.5709 26.734 11.8005 27.3407 11.7997ZM27.3407 23.5331C24.3772 20.854 22.164 18.3657 20.701 16.0683C19.2381 13.7709 18.5062 11.6441 18.5055 9.68774C18.5055 6.75441 19.3938 4.41752 21.1704 2.67707C22.947 0.936628 25.0038 0.0664062 27.3407 0.0664062C29.6783 0.0664062 31.7354 0.936628 33.512 2.67707C35.2886 4.41752 36.1766 6.75441 36.1758 9.68774C36.1758 11.6433 35.4443 13.7702 33.9814 16.0683C32.5184 18.3665 30.3049 20.8547 27.3407 23.5331Z",
    fill: "#3B7EB2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_1256_16261",
    x: 14.5055,
    y: 0.0664062,
    width: 25.6703,
    height: 31.4648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1256_16261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1256_16261",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1256_16261"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrapsiteVector);
export default __webpack_public_path__ + "static/media/trapsite_vector.1886c92cfe23155ac67c15ec2539d75c.svg";
export { ForwardRef as ReactComponent };